import { all } from 'redux-saga/effects';

import { watchRefreshAccessToken } from '../../commons/reduxModules/Authentication';
import { watchAddNotification } from '../../sagas/notificationsSaga';
import { watch as watchGtmSaga } from '../../commons/sagas/gtmSaga';

import { watch as watchInitApp } from './initAppSaga';
import { watch as watchOpenModal } from './openModalSaga';
import { watch as watchCloseModal } from './closeModalSaga';
import { watch as watchLocationChangeSaga } from './watchLocationChangeSaga';
import { watch as watchSendMessageToSupport } from './sendMessageToSupport';
import { watch as watchSendMessageToSalesman } from './sendMessageToSalesman';

function* rootSaga() {
    yield all([
        // Global
        watchRefreshAccessToken(),
        watchAddNotification(),
        watchGtmSaga(),
        // App
        watchInitApp(),
        watchOpenModal(),
        watchLocationChangeSaga(),
        watchSendMessageToSupport(),
        watchSendMessageToSalesman(),
        watchCloseModal(),
    ]);
}

export default rootSaga;
